import { render, staticRenderFns } from "./UploadQR.vue?vue&type=template&id=2f2a37f8"
import script from "./UploadQR.vue?vue&type=script&lang=js"
export * from "./UploadQR.vue?vue&type=script&lang=js"
import style0 from "./UploadQR.vue?vue&type=style&index=0&id=2f2a37f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports